import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import Styles from './BrandKitFonts.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { useEffect, useMemo, useState } from 'react'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'
import { FontRole } from 'types'
import { FontPairing, FontPairingStyle } from 'constants/fontPairings'
import { BrandKitFontSelector } from './BrandKitFontSelector'
import { Text } from 'blaze-ui/Text/Text'
import { FontPairingState } from 'components/FirstTimeExperienceModal/Types'

interface Props extends DrawerProps {
  fontPairingState: FontPairingState
  selectedFontPairing: FontPairing
  setSelectedFontPairing: (fontPairing: FontPairing) => void
  onConfirm: () => void
}

export const FontsDrawer = observer(
  ({ fontPairingState, selectedFontPairing, setSelectedFontPairing, onConfirm, ...props }: Props) => {
    const { drawersStore } = useRootStore()

    const [fontPairing, setFontPairing] = useState<FontPairing>(selectedFontPairing)
    const originalFontPairing = useMemo(() => fontPairing, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
      setSelectedFontPairing(fontPairing)
    }, [fontPairing, setSelectedFontPairing])

    return (
      <Drawer.Root {...props}>
        <Drawer.Portal>
          <Drawer.Content>
            <Drawer.InnerContent>
              <Drawer.Top>
                <Drawer.Back
                  variant="ghost"
                  position="left"
                  onPress={() => {
                    setSelectedFontPairing(originalFontPairing)
                    drawersStore.closeDrawer()
                  }}
                />
                <Drawer.Title asChild>
                  <Heading level={5}>Pick your Fonts</Heading>
                </Drawer.Title>
                <Drawer.Action variant="ghost" position="right" onPress={onConfirm}>
                  Save
                </Drawer.Action>
              </Drawer.Top>
              <Drawer.Container padding="5px 15px 15px 15px">
                <div className={Styles.drawerContent}>
                  <div className={Styles.brandKitFonts}>
                    <div className={Styles.header}>
                      <Text variant="metadata" color="var(--dark-60)">
                        We will use them to make your posts and marketing materials look awesome.
                      </Text>
                    </div>
                    <BrandKitFontSelector
                      fontRole={FontRole.Title}
                      label={fontPairing[0]?.style.font_family}
                      fontSize={24}
                      fontPairingState={fontPairingState}
                      selectedFontStyle={fontPairing[0]}
                      setSelectedFontStyle={(fontStyle) =>
                        setFontPairing([fontStyle as FontPairingStyle<FontRole.Title>, fontPairing[1]])
                      }
                    />
                    <BrandKitFontSelector
                      fontRole={FontRole.Body}
                      label={fontPairing[1]?.style.font_family}
                      fontSize={16}
                      selectedFontStyle={fontPairing[1]}
                      fontPairingState={fontPairingState}
                      setSelectedFontStyle={(fontStyle) =>
                        setFontPairing([fontPairing[0], fontStyle as FontPairingStyle<FontRole.Body>])
                      }
                    />
                  </div>
                </div>
              </Drawer.Container>
            </Drawer.InnerContent>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    )
  },
)
